var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3302 4.24721C12.7908 3.862 10.0663 3.92804 7.60489 4.43787C5.1623 4.94381 3.02404 5.87842 1.63547 7.17752C0.210303 8.5108 -0.411712 10.2519 0.288729 12.0128C0.939847 13.6497 2.59715 14.9219 4.66646 15.7711C6.48053 16.5156 8.65479 16.9571 10.9095 17.0648V19.2727L15.2726 16.1149L10.9095 12.7273V14.8803C8.90289 14.7741 7.01747 14.3776 5.49462 13.7526C3.66251 13.0008 2.64927 12.0448 2.31574 11.2063C2.03155 10.4919 2.17174 9.66345 3.12574 8.77087C4.11634 7.84412 5.827 7.03425 8.04731 6.57435C10.2488 6.11834 12.7127 6.05692 15.003 6.40435C17.3065 6.75378 19.2036 7.48105 20.416 8.38851C21.6266 9.29451 21.9216 10.1763 21.7852 10.8692C21.6328 11.6427 20.879 12.5997 19.2253 13.4267C18.6865 13.6961 18.4681 14.3514 18.7375 14.8902C19.0069 15.4291 19.6621 15.6476 20.2009 15.3782C22.1161 14.4205 23.5832 13.0292 23.9256 11.291C24.2838 9.47222 23.3166 7.83419 21.7231 6.64163C20.1317 5.45057 17.8564 4.63042 15.3302 4.24721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.d39375059f23f03da6189987d1657085.svg";
export { ForwardRef as ReactComponent };